import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import VideocamIcon from "@mui/icons-material/Videocam";

const PlaybackPlaceholder = ({ isLoading = false }) => {
  const theme = useTheme();

  if (isLoading) {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.primary.background ?? "#f5f5f5",
        }}
      >
        <Typography sx={{ color: "#777", fontSize: 14 }}>
          Loading playback records...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        backgroundColor: theme.palette.primary.background ?? "#f5f5f5",
      }}
    >
      <VideocamIcon sx={{ fontSize: 64, color: "rgba(0,0,0,0.2)" }} />
      <Typography sx={{ color: "#777", fontSize: 14 }}>
        <FormattedMessage
          id="playback.select_camera_hint"
          defaultMessage="Select a camera on the left to view playbacks."
        />
      </Typography>
    </Box>
  );
};

PlaybackPlaceholder.propTypes = {
  isLoading: PropTypes.bool,
};

export default PlaybackPlaceholder;
